<div class="cdur-modal">
  <header class="cdur-header">
    <h2>Nueva solicitud de actualización</h2>
    <button (click)="cancel()" class="cdur-close" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <!-- Paso 1: seleccionar usuario -->
  <section *ngIf="!selectedUser" class="cdur-section">
    <h3>1. Seleccionar usuario</h3>
    <div class="cdur-search">
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (keyup.enter)="search()"
        placeholder="ID de usuario, nombre o número de documento..."
        class="cdur-input"
      />
      <button class="cdur-btn cdur-btn--primary" (click)="search()" [disabled]="searching">
        <mat-spinner *ngIf="searching" diameter="14"></mat-spinner>
        <mat-icon *ngIf="!searching">search</mat-icon>
        Buscar
      </button>
    </div>

    <ul *ngIf="searchResults.length" class="cdur-results">
      <li *ngFor="let u of searchResults" (click)="selectUser(u)" class="cdur-result">
        <div>
          <strong>{{ u.nombre }} {{ u.apellidos }}</strong>
          <small>{{ u.email }} · #{{ u.usuarioId }} · {{ u.numeroId }}</small>
        </div>
        <span
          *ngIf="u.tipoUsuarioId === 1"
          class="cdur-badge cdur-badge--company"
        >Empresa</span>
        <span
          *ngIf="u.activeRequestId"
          class="cdur-badge cdur-badge--active"
        >Solicitud activa</span>
      </li>
    </ul>

    <p *ngIf="!searching && searchQuery && !searchResults.length" class="cdur-muted">
      Sin resultados.
    </p>
  </section>

  <!-- Pasos 2-4 -->
  <ng-container *ngIf="selectedUser">
    <section class="cdur-section">
      <header class="cdur-user">
        <div>
          <strong>{{ selectedUser.nombre }} {{ selectedUser.apellidos }}</strong>
          <small>{{ selectedUser.email }} · #{{ selectedUser.usuarioId }} · {{ selectedUser.numeroId }}</small>
        </div>
        <button class="cdur-btn cdur-btn--ghost" (click)="changeUser()">
          Cambiar
        </button>
      </header>

      <div *ngIf="showComplianceWarning" class="cdur-banner cdur-banner--warn">
        <mat-icon>info</mat-icon>
        Este usuario está rechazado o en blacklist: no se le pueden pedir documentos.
      </div>
    </section>

    <section class="cdur-section">
      <h3>2. Campos a solicitar</h3>
      <div class="cdur-fields">
        <div *ngFor="let f of visibleFields" class="cdur-field-check">
          <!-- Checkbox + label clickeable. El thumbnail vive AFUERA
               del label para que su click no togglee el campo. -->
          <label class="cdur-field-check__row">
            <input
              type="checkbox"
              [checked]="isFieldSelected(f.fieldKey)"
              (change)="toggleField(f.fieldKey)"
            />
            <div class="cdur-field-check__main">
              <span class="cdur-field-check__label">{{ labelOfField(f) }}</span>
              <ng-container *ngIf="!isFileField(f.fieldKey)">
                <span
                  class="cdur-field-check__current"
                  [class.cdur-field-check__current--empty]="!currentValueOf(f.fieldKey)"
                >
                  {{ currentValueOf(f.fieldKey) || 'Sin dato' }}
                </span>
              </ng-container>
            </div>
            <div class="cdur-field-check__tags">
              <small *ngIf="f.companyOnly">empresa</small>
              <small *ngIf="f.requiresCompliance">requiere compliance</small>
            </div>
          </label>

          <!-- Thumbnail clickeable: abre lightbox para imágenes, nueva
               pestaña para PDFs. Vive afuera del label de arriba. -->
          <ng-container *ngIf="isFileField(f.fieldKey)">
            <button
              *ngIf="currentDocUrlOf(f.fieldKey) as url"
              type="button"
              class="cdur-field-check__thumb cdur-field-check__thumb--clickable"
              (click)="previewDocument(url, $event)"
              title="Ver documento en grande"
            >
              <img [src]="url" alt="Documento actual" />
              <span class="cdur-field-check__thumb-zoom">
                <mat-icon>zoom_in</mat-icon>
              </span>
            </button>
            <span
              *ngIf="!currentDocUrlOf(f.fieldKey)"
              class="cdur-field-check__thumb cdur-field-check__thumb--empty"
              title="Sin vista previa disponible"
            >
              <mat-icon>image_not_supported</mat-icon>
            </span>
          </ng-container>
        </div>
      </div>
    </section>

    <section class="cdur-section">
      <h3>3. Plazo y motivo</h3>
      <div class="cdur-row">
        <label class="cdur-label">
          Plazo límite
          <input
            type="date"
            [(ngModel)]="deadlineAt"
            [min]="todayIso"
            class="cdur-input"
            onclick="this.showPicker && this.showPicker()"
            onfocus="this.showPicker && this.showPicker()"
          />
        </label>
        <label class="cdur-label cdur-label--grow">
          Motivo (visible para el cliente)
          <textarea
            [(ngModel)]="motivo"
            rows="3"
            placeholder="Ej: Documento de identidad vencido"
            class="cdur-input cdur-textarea"
          ></textarea>
        </label>
      </div>
    </section>

    <div *ngIf="errorMessage" class="cdur-banner cdur-banner--err">
      <mat-icon>error_outline</mat-icon> {{ errorMessage }}
    </div>

    <footer class="cdur-footer">
      <button class="cdur-btn cdur-btn--ghost" (click)="cancel()" [disabled]="saving">
        Cancelar
      </button>
      <button class="cdur-btn cdur-btn--primary" (click)="submit()" [disabled]="saving">
        <mat-spinner *ngIf="saving" diameter="14"></mat-spinner>
        <mat-icon *ngIf="!saving">send</mat-icon>
        Crear solicitud
      </button>
    </footer>
  </ng-container>

  <!-- Lightbox fullscreen para previsualizar el documento actual. -->
  <div
    *ngIf="lightboxUrl"
    class="cdur-lightbox"
    (click)="closeLightbox()"
    role="dialog"
    aria-modal="true"
  >
    <button
      type="button"
      class="cdur-lightbox__close"
      (click)="$event.stopPropagation(); closeLightbox()"
      aria-label="Cerrar"
    >
      <mat-icon>close</mat-icon>
    </button>
    <img
      [src]="lightboxUrl"
      alt="Documento actual"
      class="cdur-lightbox__img"
      (click)="$event.stopPropagation()"
    />
  </div>
</div>
